export enum SensorUnit {
  Rpm = 'об/мин',
}
